var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 39,
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 44,
    width: 2,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4,10.1l-8-4C50.3,6,50.2,6,50,6h-8V3c0-1.7-1.3-3-3-3h-2c-0.8,0-1.5,0.3-2,0.7C34.5,0.2,33.8,0,33,0h-2 c-0.8,0-1.5,0.3-2,0.7C28.5,0.2,27.8,0,27,0h-2c-0.8,0-1.5,0.3-2,0.7C22.5,0.2,21.8,0,21,0h-2c-1.7,0-3,1.3-3,3v3H2 C1.4,6,1,6.4,1,7v8c0,0.6,0.4,1,1,1h14v13h-1c-0.6,0-1,0.4-1,1v6c0,0.6,0.4,1,1,1h2v23h2V37h21v23h2V37h1c0.6,0,1-0.4,1-1v-6 c0-0.6-0.4-1-1-1h-2.3c1.9-1.9,4.3-5.4,4.3-10v-2c0-0.4-0.1-0.7-0.2-1H50c0.2,0,0.3,0,0.4-0.1l8-4c0.4-0.2,0.6-0.5,0.6-0.9 S58.7,10.3,58.4,10.1z M37,2h2c0.6,0,1,0.4,1,1v11h-4v-2V3C36,2.4,36.4,2,37,2z M31,2h2c0.6,0,1,0.4,1,1v9v2h-4v-2V3 C30,2.4,30.4,2,31,2z M25,2h2c0.6,0,1,0.4,1,1v9v2.2c-1.2,0.4-2,1.5-2,2.8h-1c-0.6,0-1-0.4-1-1V3C24,2.4,24.4,2,25,2z M18,3 c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v13c0,0.6-0.4,1-1,1h-2c-0.6,0-1-0.4-1-1V3z M16,10h-6V8h6V10z M3,8h5v6H3V8z M10,14v-2h6v2H10 z M42,35h-1H18h-2v-4h1h21h4V35z M37.7,29H18V18.8c0.3,0.1,0.6,0.2,1,0.2h2c0.8,0,1.5-0.3,2-0.7c0.5,0.5,1.2,0.7,2,0.7h1 c0,1.7,1.3,3,3,3h13c0.2,0,0.4,0,0.6-0.1C41.5,25.9,38.6,28.4,37.7,29z M43,17v2c0,0.6-0.4,1-1,1H29c-0.6,0-1-0.4-1-1v-2 c0-0.6,0.4-1,1-1h11h1h1C42.6,16,43,16.4,43,17z M49.8,14H42v-2h5v-2h-5V8h7v4h2V8.6l4.8,2.4L49.8,14z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.8c3e6c360777afd0b5fbf3ef4b6009e8.svg";
export { ForwardRef as ReactComponent };